module.exports = __webpack_public_path__ + "img/199.a93244d3.jpg";